import {
  ISharedOption,
  ISharedWithUser
} from './User';

export enum SharingSettingsTypes {
  DATABASE,
  NOTEBOOK,
  REPORT,
  INTEGRATION,
}

type Item = {
  label: string;
  value: string;
  [key: string]: string;
}

export const optionsShareResource: Item[] = [ // Databases + Integrations
  {
    label: 'can view',
    value: 'view'
  },
  {
    label: 'can use',
    value: 'use'
  },
  {
    label: 'can edit',
    value: 'edit'
  }
];

export interface ResourceSharingSettings {
  uid?: string;
  shared_with_workspace: ISharedOption;
  shared_with_users: ISharedWithUser[];
  shared_with_groups: ISharedWithUser[];
  type: string;
}

export interface ReportSharingSettings extends ResourceSharingSettings {
}
